module.exports = __webpack_public_path__ + "static/media/my.6c342b03.svg";